import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import CategoryList from "../../features/manageCategories/categoryList";
import CategoryTopbar from "../../features/manageCategories/topbar";
import {
  Box,
  Button,
  IconButton,
  Switch,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { a11yProps } from "../manageMaintenanceTeam";
import React, { useEffect, useState } from "react";
import { showError, showToast } from "../../constants/toasts";
import { GridColDef } from "@mui/x-data-grid";
import {
  useAddCategoryMutation,
  useDeleteCategoryMutation,
  useLazyGetCategoryQuery,
  useUpdateCategoryMutation,
} from "../../services/categories";
import moment from "moment";
import AddCategory from "../../Modals/addCategory";
import { ConfirmationModal } from "../../Modals/ConfirmationModal";
import CustomToggle from "../../helpers/CustomToggle";

const ManageCategories = () => {
  const navigate = useNavigate();
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [fetchCategories, { isLoading }] = useLazyGetCategoryQuery();
  const [addCategory, { isLoading: addLoading }] = useAddCategoryMutation();
  const [updateStatus] = useUpdateCategoryMutation();
  const [deletecategory] = useDeleteCategoryMutation();

  const [confirmation, setConfirmation] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [add, setAdd] = useState(false);
  const [open, setOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [openStatusConfirm, setOpenStatusConfirm] = useState(false);
  const [edit, setEdit] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [statusToUpdate, setStatusToUpdate] = useState<{id: string, status: boolean} | null>(null);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [totalCount, setTotalCount] = useState<number>(0);
  const [page, setPage] = useState(1);
  const [categoriesList, setCategoriesList] = useState([]);

  const onPageChange = (_: any, newPage: number) => {
    setPage(newPage);
  };

  const columns: GridColDef<(typeof categoriesList)[number]>[] = React.useMemo(() => {
    const nameColumn: GridColDef = {
      flex: 2,
      minWidth: 220,
      field: "name",
      headerName: "Category Name",
      editable: false,
      sortable: false,
    };

    const dateColumn: GridColDef = {
      flex: 1,
      minWidth: 180,
      field: "date",
      headerName: "Created Date",
      editable: false,
      sortable: false,
      renderCell: (_: any) => {
        return (
          <Typography>{moment(_?.createdAt).format("DD MMMM YYYY")}</Typography>
        );
      },
    };

    const subCategoryColumn: GridColDef = {
      flex: 1,
      minWidth: 150,
      field: "subCatogery",
      headerName: "subCatogery",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params: any) => (
        <Button
          className="btn sm btn_primary"
          onClick={() =>
            navigate(`/manage-categories/subcategory/${params?.row?._id}`, {
              state: `${valueTabs}`,
            })
          }
        >
          View
        </Button>
      ),
    };

    const statusColumn: GridColDef = {
      flex: 1,
      minWidth: 100,
      field: "status",
      headerName: "Status",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }: any) => {
        return (
          <CustomToggle
            checked={!row?.isBlocked}
            onChange={() => {
              setStatusToUpdate({ id: row?._id, status: !row?.isBlocked });
              setOpenStatusConfirm(true);
            }}
            id={row?._id}
          />
        );
      },
    };

    const actionColumn: GridColDef = {
      minWidth: 130,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }: any) => {
        return (
          <div className="table_actions v2">
            <Box>
              <IconButton
                onClick={() => {
                  setSelectedId(row?._id);
                  setCategoryName(row?.name || "");
                  setEdit(true);
                  setOpen(true);
                }}
              >
                <img src="/static/images/edit2_icon.svg" alt="" />
              </IconButton>
            </Box>
            <Box>
              <IconButton
                onClick={() => {
                  setSelectedId(row?._id);
                  setOpenDelete(true);
                }}
              >
                <img src="/static/images/trash2_icon.svg" alt="" />
              </IconButton>
            </Box>
          </div>
        );
      },
    };

    const finalColumns: GridColDef[] = [nameColumn, dateColumn];

    if (valueTabs === 1) {
      finalColumns.push(subCategoryColumn);
    }

    finalColumns.push(statusColumn, actionColumn);

    return finalColumns as GridColDef<(typeof categoriesList)[number]>[];
  }, [valueTabs]);

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handleDelete = async () => {
    try {
      const response = await deletecategory({ id: selectedId }).unwrap();
      if (response?.statusCode === 200) {
        showToast("Deleted Successfully");
        getCategories();
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const handleStatusUpdate = async (id: string, status: boolean) => {
    const body = {
      isBlocked: status,
    };

    try {
      const response = await updateStatus({ body, id }).unwrap();
      if (response?.statusCode === 200) {
        showToast(
          `Category ${!status ? "activated" : "deactivated"} successfully`
        );
        getCategories();
      } else {
        showError("Please try again");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const handleConfirmedStatusUpdate = async () => {
    if (statusToUpdate) {
      await handleStatusUpdate(statusToUpdate.id, statusToUpdate.status);
      setOpenStatusConfirm(false);
      setStatusToUpdate(null);
    }
  };

  const handleSubmit = async (name: string) => {
    if (!name?.length) {
      showError("Please input catgory name");
      return;
    }
    try {
      let response = {} as any;
      if (edit) {
        response = await updateStatus({
          body: {
            name,
          },
          id: selectedId,
        } as any).unwrap();
      } else {
        response = await addCategory({
          name,
          categoryType: valueTabs ? "STORAGE" : "VENUE",
        }).unwrap();
      }
      if (response?.statusCode === 200) {
        setCategoryName("");
        setAdd(false);
        setOpen(false);
        setEdit(false);
        getCategories();
        showToast(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      console.log(error);
    }
  };

  const getCategories = async () => {
    try {
      const response = await fetchCategories({
        page,
        limit: 10,
        search: debouncedSearchTerm.trim(),
        categoryType: valueTabs ? "STORAGE" : "VENUE",
      }).unwrap();
      if (response?.statusCode === 200) {
        setCategoriesList((response?.data?.data || []) as any);
        setTotalCount(response?.data?.total);
      } else {
        setCategoriesList([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getCategories();
  }, [debouncedSearchTerm, page, valueTabs]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage Categories</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage
          Categories
        </p>
      </div>
      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Venue" {...a11yProps(0)} />
              <Tab label="Storage" {...a11yProps(1)} />
            </Tabs>
          </Box>
        </div>
      </div>
      <div className="cards">
        <CategoryTopbar
          searchTerm={searchTerm}
          setDebouncedSearchTerm={setDebouncedSearchTerm}
          setSearchTerm={setSearchTerm}
          toggleModal={() => setOpen(true)}
        />
        <CategoryList
          count={totalCount}
          page={page}
          loading={isLoading}
          onPageChange={onPageChange}
          rows={categoriesList || []}
          columns={columns}
        />
      </div>
      <AddCategory
        edit={edit}
        value={categoryName || ""}
        setCategoryName={setCategoryName}
        loading={addLoading}
        handleSubmit={handleSubmit}
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
      />

      <ConfirmationModal
        text={"Are you sure to delete this category"}
        openModal={openDelete}
        setOpenModal={setOpenDelete}
        handleSubmit={handleDelete}
      />

      <ConfirmationModal
        text={`Are you sure you want to ${statusToUpdate?.status ? 'deactivate' : 'activate'} this category?`}
        openModal={openStatusConfirm}
        setOpenModal={setOpenStatusConfirm}
        handleSubmit={handleConfirmedStatusUpdate}
      />
    </MainContainer>
  );
};

export default ManageCategories;
